import { withParams } from 'vuelidate'

export default () =>
  withParams({ type: 'greaterThanZero' }, function(value) {
    if (value === null || value === undefined || value === '') return true
    return parseFloat(value) > 0
  })